<template>
  <v-layout
    id="scale"
    class="home-footer-info"
    style="flex: none; height: 100%"
  >
    <v-layout v-if="!editingScale" @click="editScale">
      <label>{{ $t("Scale") }} 1:</label>
      <span>{{ scale }}</span>
    </v-layout>

    <v-layout v-else v-on-clickaway="cancelEdit">
      <label>{{ $t("Scale") }} 1:</label>
      <input
        type="number"
        v-model="scale"
        style="width: 60px; background-color:#e8e8e8 "
        :min="0"
        spellcheck="false"
        v-on:keyup.enter="saveScale(scale)"
        v-on:keyup.esc="cancelEdit"
      />
    </v-layout>
  </v-layout>
</template>

<script>
import { bus } from "@/main";
import { mixin as clickaway } from "vue-clickaway";

export default {
  name: "HomeFooterScale",

  mixins: [clickaway],

  data() {
    return {
      scale: "",
      originalScale: "",
      editingScale: false
    };
  },

  mounted() {
    bus.$on("update-home-footer-map-scale", scale => {
      this.scale = Math.round(scale);
      this.originalScale = this.scale;
    });
  },

  destroyed() {
    bus.$off("update-home-footer-map-scale");
  },

  methods: {
    editScale() {
      if (!this.editingScale) {
        this.editingScale = true;
      }
    },

    cancelEdit() {
      this.scale = this.originalScale;
      this.editingScale = false;
    },

    saveScale(scale) {
      if (scale && scale > 0) {
        bus.$emit("change-home-map-scale", scale);
        this.cancelEdit();
      }
    }
  }
};
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input:invalid {
  border: 1px solid var(--red);
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Footer/Scale.vue